import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty"; //@ts-check

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Drawer from '@material-ui/core/Drawer';
import Avatar from '@material-ui/core/Avatar';
import { withStyles, createStyles } from '@material-ui/core/styles';
import { darken } from '@material-ui/core/styles/colorManipulator';
import Formatter from '../../../../../formatter';

var styles = function styles(theme) {
  return createStyles({
    userBox: {
      color: '#FFF',
      height: theme.common.Page.NavBar.style.height,
      cursor: 'pointer',
      userSelect: 'none',
      paddingRight: theme.spacing(2),
      '&:hover': {
        backgroundColor: theme.common.Page.NavBar.style.hoverBackground
      },
      '&:focus, &:active': {
        backgroundColor: theme.common.Page.NavBar.style.activeBackground
      }
    },
    userBoxText: _defineProperty({
      color: theme.common.Page.NavBar.style.color,
      fontWeight: 'bold',
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(0.5)
    }, theme.breakpoints.down('xs'), {
      display: 'none'
    }),
    userBoxPicture: {
      '& > *': {
        height: 24,
        width: 24,
        fontSize: 24 / 2
      }
    },
    drawer: {
      width: 300,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    drawerUser: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      textAlign: 'center'
    },
    drawerUserText: {
      paddingTop: theme.spacing(2)
    },
    drawerUserPicture: {
      margin: 'auto',
      paddingTop: theme.spacing(2),
      '& > *': {
        height: 96,
        width: 96,
        fontSize: Math.floor(96 / 3)
      }
    },
    drawerDivider: {
      opacity: 0
    }
  });
};
/**
 * @extends {React.Component<import('./types').UserProps & import('@material-ui/core').WithStyles<typeof styles>>}
 */


var User =
/*#__PURE__*/
function (_React$Component) {
  _inherits(User, _React$Component);

  function User() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, User);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(User)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      open: false
    };

    _this.toggleDrawer = function (open) {
      _this.setState({
        open: open
      });
    };

    _this.renderProfilePicture = function () {
      var _this$props = _this.props,
          userDisplayName = _this$props.userDisplayName,
          userProfileImage = _this$props.userProfileImage;

      if (userProfileImage) {
        return React.createElement(Avatar, {
          alt: userDisplayName,
          src: userProfileImage
        });
      } else {
        return React.createElement(Formatter.LetterAvatar, {
          text: userDisplayName
        });
      }
    };

    _this.renderDrawerEntry = function (entry) {
      var linkComponent = _this.props.linkComponent;
      var component = entry.type === 'button' ? Button : linkComponent;

      var props = _objectSpread({}, entry.props);

      props.onClick = function () {
        if (entry.props.onClick) entry.props.onClick();

        _this.toggleDrawer(false);
      };

      return React.createElement(ListItem, Object.assign({
        button: true,
        key: entry.label,
        component: component
      }, props), React.createElement(ListItemText, {
        primary: entry.label
      }));
    };

    _this.renderDrawer = function () {
      var _this$props2 = _this.props,
          classes = _this$props2.classes,
          userDisplayName = _this$props2.userDisplayName,
          drawerEntries = _this$props2.drawerEntries;
      return React.createElement("div", {
        className: classes.drawer,
        role: "presentation"
      }, React.createElement(Grid, {
        container: true,
        className: classes.drawerUser,
        direction: "column",
        wrap: "nowrap"
      }, React.createElement(Grid, {
        item: true,
        className: classes.drawerUserPicture
      }, _this.renderProfilePicture()), React.createElement(Grid, {
        item: true
      }, React.createElement(Typography, {
        variant: "h6",
        className: classes.drawerUserText
      }, userDisplayName))), drawerEntries.map(function (group, idx) {
        var groupItems = group.map(_this.renderDrawerEntry).filter(function (e) {
          return Boolean(e);
        });
        return Boolean(groupItems.length) && React.createElement(React.Fragment, {
          key: idx
        }, React.createElement(List, null, groupItems), idx < drawerEntries.length - 1 && React.createElement(Divider, {
          className: classes.drawerDivider
        }));
      }));
    };

    return _this;
  }

  _createClass(User, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          classes = _this$props3.classes,
          theme = _this$props3.theme,
          linkComponent = _this$props3.linkComponent,
          drawerEntries = _this$props3.drawerEntries,
          userDisplayName = _this$props3.userDisplayName,
          userProfileImage = _this$props3.userProfileImage,
          rest = _objectWithoutProperties(_this$props3, ["classes", "theme", "linkComponent", "drawerEntries", "userDisplayName", "userProfileImage"]);

      var open = this.state.open;
      return React.createElement(React.Fragment, null, React.createElement("div", rest, React.createElement(Button, {
        "aria-owns": open ? 'navbar-user-drawer' : undefined,
        "aria-haspopup": "true",
        onClick: function onClick() {
          return _this2.toggleDrawer(true);
        },
        className: classes.userBox
      }, React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, React.createElement(Grid, {
        item: true,
        className: classes.userBoxPicture
      }, this.renderProfilePicture()), React.createElement(Grid, {
        item: true
      }, React.createElement(Typography, {
        className: classes.userBoxText
      }, userDisplayName))))), React.createElement(Drawer, {
        id: "navbar-user-drawer",
        anchor: "right",
        open: open,
        onClose: function onClose() {
          return _this2.toggleDrawer(false);
        },
        disableRestoreFocus: true
      }, this.renderDrawer()));
    }
  }]);

  return User;
}(React.Component);
/**@type {Partial<import('./types').UserProps>} */


User.defaultProps = {
  linkComponent: 'a',
  userProfileImage: null
};
export default withStyles(styles, {
  withTheme: true,
  name: 'ECUser'
})(User);